import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { CARTA, tr } from "@/data/carta";
import { Reveal, SectionHead } from "./Reveal";

export const Carta = () => {
  const { t, lang } = useLang();
  const [active, setActive] = useState(CARTA[0].id);
  const cat = CARTA.find((c) => c.id === active) ?? CARTA[0];

  return (
    <section id="carta" data-testid="carta-section" className="relative bg-tropical-dark text-paper py-24 lg:py-36 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead id="carta" dark eyebrow={t.carta.eyebrow} title={t.carta.title} />
        <Reveal delay={0.05}><p className="mt-6 max-w-2xl text-base sm:text-lg text-paper/85 leading-relaxed" data-testid="carta-intro">{t.carta.intro}</p></Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex gap-2 sm:gap-3 overflow-x-auto pb-2" data-testid="carta-tabs">
            {CARTA.map((c) => (
              <button
                key={c.id}
                data-testid={`carta-tab-${c.id}`}
                onClick={() => setActive(c.id)}
                className={`shrink-0 rounded-full px-5 py-2.5 text-[12px] font-bold uppercase tracking-[0.12em] border transition-colors ${active === c.id ? "bg-banana text-jungle border-banana" : "border-paper/25 text-paper/85 hover:border-banana hover:text-banana"}`}
              >
                {tr(c.name, lang)}
              </button>
            ))}
          </div>
        </Reveal>
        <h3 className="mt-12 font-display italic text-3xl sm:text-4xl text-banana" data-testid="carta-category-title">{tr(cat.name, lang)}</h3>
        <p className="mt-3 max-w-xl text-paper/80" data-testid="carta-chapter-intro">{t.carta.chapters[cat.id]}</p>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-14" data-testid="carta-items">
          {cat.items.map((it, i) => (
            <motion.div
              key={`${cat.id}-${i}`}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06, duration: 0.5 }}
              className="group flex items-baseline gap-5 py-5 border-b border-paper/25"
              data-testid={`carta-item-${i}`}
            >
              <span className="font-mono-ed text-sm text-paper/90">0{i + 1}</span>
              <p className="font-display text-xl sm:text-2xl group-hover:text-banana group-hover:translate-x-1 transition-[color,transform] duration-300">{tr(it, lang)}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-12 inline-block rounded-full border border-banana/50 px-5 py-3 font-neon text-2xl text-banana" data-testid="carta-note">{t.carta.note}</p>
      </div>
    </section>
  );
};
